<div class="card">
    <div class="card-header bg-primary">
        <h3 class="card-title">Censimento Dispositivi</h3>
    </div>
    <div class="card-body">
        <form [formGroup]="devicesForm" class="p-fluid">
            <div class="row">
                <h3 class="col-md-2 card-title">
                    {{this.currentId === "" ? "Modalità Creazione" : "Modalità Modifica"}}</h3>
                <p-button iconPos="left" type="button" [disabled]='this.currentId === ""' (click)="modCreazione()"
                    pTooltip="Passa a Modalità Creazione">
                    {{this.currentId === "" ? "Creazione On" : "Passa a Creazione"}}
                </p-button>
            </div>
            <div class="row">
                <span class="col-md-6 mt-2">
                    <label for="id">Id dispositivo:{{(isRequired("id") ? "*" : "")}}</label>
                    <input formControlName="id" type="text" id="id" placeholder="Inserire Id del dispositivo"
                        pInputText />
                    <small *ngIf="devicesForm.get('id').invalid && devicesForm.get('id').touched"
                        class="p-error block">Campo obbligatorio.</small>
                </span>
                <span class="col-md-6 mt-2">
                    <label for="mac">Mac:{{(isRequired("mac") ? "*" : "")}}</label>
                    <p-inputMask formControlName="mac" type="text" id="mac"
                        placeholder="Inserire indirizzo Mac dispositivo" mask="**:**:**:**:**:**">
                    </p-inputMask>
                    <small *ngIf="devicesForm.get('mac').invalid && devicesForm.get('mac').touched"
                        class="p-error block">Campo obbligatorio.</small>
                </span>
            </div>
            <div class="row">
                <span class="col-md-6 mt-2">
                    <label for="status">Stato dispositivo:{{(isRequired("status") ? "*" : "")}}</label>
                    <p-dropdown id="status" [options]="status" formControlName="status"
                        dropdownIcon="fas fa-chevron-down">
                    </p-dropdown>
                    <small *ngIf="devicesForm.get('status').invalid && devicesForm.get('status').touched"
                        class="p-error block">Campo obbligatorio.</small>
                </span>
                <span class="col-md-6 mt-2">
                    <label for="misurazioni">Misurazioni consentite dal dispositivo:{{(isRequired("misurazioni") ? "*" :
                        "")}}</label>
                    <p-multiSelect appendTo="body" class="p-fluid" [options]="misurazioni" formControlName="misurazioni"
                        placeholder="Seleziona misurazioni consentite" optionLabel="label"
                        (onChange)="getMisurazioniOnChange($event)">
                    </p-multiSelect>
                    <small *ngIf="devicesForm.get('misurazioni').invalid && devicesForm.get('misurazioni').touched"
                        class="p-error block">Campo obbligatorio.</small>
                </span>
            </div>
            <div class="row">
                <span class="col-md-6 mt-2">
                    <label for="manufacturer">Marca dispositivo:{{(isRequired("manufacturer") ? "*" : "")}}</label>
                    <input formControlName="manufacturer" type="text" id="manufacturer"
                        placeholder="Inserire marca dispositivo" pInputText />
                    <small *ngIf="devicesForm.get('manufacturer').invalid && devicesForm.get('manufacturer').touched"
                        class="p-error block">Campo obbligatorio.</small>
                </span>
                <span class="col-md-6 mt-2">
                </span>
            </div>
            <div class="row">
                <span class="col-md-6 mt-2">
                    <label for="model">Modello dispositivo:{{(isRequired("model") ? "*" : "")}}</label>
                    <input formControlName="model" type="text" id="model" placeholder="Inserire modello dispositivo"
                        pInputText />
                    <small *ngIf="devicesForm.get('model').invalid && devicesForm.get('model').touched"
                        class="p-error block">Campo obbligatorio.</small>
                </span>
                <span class="col-md-6 mt-2">
                </span>
            </div>
            <div class="row">
                <span class="col-md-6 mt-2">
                    <label for="version">Versione dispositivo:{{(isRequired("version") ? "*" : "")}}</label>
                    <input formControlName="version" type="text" id="version"
                        placeholder="Inserire versione software/firmware" pInputText />
                    <small *ngIf="devicesForm.get('version').invalid && devicesForm.get('version').touched"
                        class="p-error block">Campo obbligatorio.</small>
                </span>
                <span class="col-md-6 mt-2">
                </span>
            </div>
            <div class="row mt-2">
                <div class="col-md-12">
                    <div class="float-right">
                        <button pButton label="Salva" icon="fa fa-save" iconPos="left" id="saveDevice"
                            class="p-button-success" type="button" (click)="save()"></button>
                    </div>
                </div>
            </div>
        </form>
        <div class="row mt-2">
            <div class="col-md-12">
                <div class="card-body">
                    <div class="row mt-2">
                        <div class="col-md-12">
                            <p-table #dt [columns]="colonne" [value]="rows" [lazy]="true" [paginator]="true" [rows]="10"
                                [totalRecords]="page.totalElements" [loading]="loading" [responsive]="true"
                                (onLazyLoad)="setPage($event)" sortMode="multiple" [(first)]="first">
                                <ng-template pTemplate="header" let-columns>
                                    <tr>
                                        <th style="width:6em">
                                            <div style="display: inline-block;">
                                                {{colonne[0].name}}
                                            </div>
                                        <th style="width:6em">
                                            <div style="display: inline-block;">
                                                {{colonne[1].name}}
                                            </div>
                                        </th>
                                        <th style="width:4em">
                                            {{colonne[2].name}}
                                        </th>
                                        <th style="width:4em">
                                            {{colonne[3].name}}
                                        </th>
                                        <th style="width:6em">Azioni</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-rowData let-columns="columns">
                                    <tr>
                                        <td *ngFor="let col of columns">
                                            <span class="p-column-title">{{col.name}}</span>
                                            {{rowData[col.prop]}}
                                        </td>
                                        <td style="text-align:center">
                                            <p-button icon="fas fa-search" iconPos="left" type="button" class="ml-2"
                                                (click)="getSingoloDevice(rowData)" pTooltip="Visualizza"></p-button>
                                            <button pButton class="p-button-danger p-button p-component ml-2"
                                                icon="fas fa-trash" iconPos="left"
                                                (click)="confirmDelete(rowData)"></button>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage" let-columns>
                                    <tr>
                                        <td [attr.colspan]="columns.length +1">
                                            <label>Nessun paziente trovato</label>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>